<template>
    <div class="factor-filter-container">
        <div class="factor-controls">
            <div class="button-container">
                <div v-for="(filter, index) in desiredFilters" :key="index">
                    <q-select class="dropdown" dropdown-icon="expand_more" align="between" no-caps :label="filter.label"
                        outline option-value="value" hide-bottom-space multiple outlined dense
                        v-model="selectedFilters[filter.key]" :options="filter.options" options-dense
                        @update:model-value="emitFilters">
                        <template v-slot:before-options>
                            <q-item>
                                <q-item-section>
                                    <q-item-label>Select All</q-item-label>
                                </q-item-section>
                                <q-item-section side>
                                    <q-checkbox :model-value="allSelected[filter.key]"
                                        @update:model-value="selectAll(filter.key)" />
                                </q-item-section>
                            </q-item>
                            <q-separator />
                        </template>
                        <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
                            <q-item v-bind="itemProps">
                                <q-item-section>
                                    {{ opt.label }}
                                </q-item-section>
                                <q-item-section side>
                                    <q-checkbox :model-value="selected" @update:model-value="toggleOption(opt)" />
                                </q-item-section>
                            </q-item>
                        </template>
                    </q-select>
                </div>

                <div v-if="filterKeys.includes('Age')" class="row">
                    <q-select
                        dense
                        v-model="ageFilterType"
                        no-caps
                        rounded
                        emit-value 
                        map-options
                        option-value="value"
                        option-label="label"
                        :options="ageFilterOptions"
                        @update:model-value="emitFilters"
                    />
                    <q-input class="dropdown" style="width: 7.5em" min="0" max="100" outlined dense v-model="ageValue" label="Age" type="number" @update:model-value="emitFilters" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "TableFilterComponent",

    props: {
        tableInformation: {
            type: Object,
            required: true,
        },

        filterKeys: {
            type: Array,
            required: true
        }
    },

    data() {
        return {

            filterObject: {},

            selectedFilters: {},
            allSelected: {},

            isResettingFilters: false,
            desiredFilters: [],

            // Selected filter type (older or younger)
            ageFilterType: 'older',
            // Age value to filter by
            ageValue: 0,
            // Filter options for dropdown
            ageFilterOptions: [
                { label: 'Older than', value: 'older' },
                { label: 'Younger than', value: 'younger' }
            ],
        };
    },


    created() {
        this.generateFilterConfig();
    },


    methods: {
        /**
         * Dynamically generate the filter options using the data provided.
         */
        generateFilterConfig() {
            const uniqueValues = (key) => [...new Set(this.tableInformation.map((item) => item[key]))];

            this.filterConfig = [
                {
                    key: 'contact_type_id',
                    label: 'Contact Type',
                    options: uniqueValues('contact_type_id').map((value) => ({ label: value, value })),
                },
                {
                    key: 'programme_id',
                    label: 'Programme',
                    options: uniqueValues('programme_id').map((value) => ({ label: value, value })),
                },
                {
                    key: 'service_type_id',
                    label: 'Service',
                    options: uniqueValues('service_type_id').map((value) => ({ label: value, value })),
                },
                {
                    key: 'gender_id',
                    label: 'Gender',
                    options: uniqueValues('gender_id').map((value) => ({ label: value, value })),
                },
                {
                    key: 'ethnicity_id',
                    label: 'Ethnicity',
                    options: uniqueValues('ethnicity_id').map((value) => ({ label: value, value })),
                }
            ]

            this.desiredFilters = this.filterConfig.filter((item) => this.filterKeys.includes(item.label));

            this.desiredFilters.forEach((filter) => {
                this.selectedFilters[filter.key] = [];
                this.allSelected[filter.key] = false;
            });
        },


        /**
         * Select All possible options for given filter key
         * @param {*} key 
         */
        selectAll(key) {
            if (this.allSelected[key]) {
                this.selectedFilters[key] = [];
            } else {
                this.selectedFilters[key] = this.filterConfig.find((f) => f.key === key).options.map(
                    (opt) => opt
                );
            }
            this.allSelected[key] = !this.allSelected[key];
            this.emitFilters();
        },


        /**
         * Emit filter changes to the parent table component
         */
        emitFilters() {
            const simpleFilters = {};
            Object.keys(this.selectedFilters).forEach((key) => {
                simpleFilters[key] = this.selectedFilters[key].map((opt) => opt.value);
            });

            if (this.filterKeys.includes('Age')) {
                    const ageFilters = {
                    type: this.ageFilterType == 'older' ? true : false,
                    age: parseInt(this.ageValue)
                };

                this.$emit('updateFilters', simpleFilters, ageFilters);
            } else {
                this.$emit('updateFilters', simpleFilters);
            }

        },
    },
};

</script>

<style src="@/assets/styles/filter.css" scoped />